<template>
  <div
    id="fancy-modal"
    hidden
  >
    {{ data }}
  </div>
</template>

<script>
import {Fancybox} from '@fancyapps/ui'

export default {
  name: 'FancyModal',
  props: {
    data: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        Fancybox.show([
          {
            src: '#fancy-modal',
            type: 'inline'
          }
        ], {
          on: {
            destroy: () => this.$emit('destroy')
          }
        })
      }
    }
  },
}
</script>

<style scoped>

</style>
